export const tree = {
    tabs: {
        id: {
            order: -1,
            enabled: ()=>true,
            default: true,
            tabGroupDefault: true,
            tabGroup: 'overview',
            parts: [
                'NodeOverview'
            ]
        },
        dbid: {
            acl: 'g:debug',
            parts: [
                'DatabaseTables'
            ],
            enabled: ()=>true,
            tabGroup: 'overview',
            order: 997
        },
        error: {
            acl: 'g:debug',
            parts: [
                'SysError'
            ],
            datatype: [
                0,
                1,
                2,
                3,
                7,
                9,
                10,
                13,
                16,
                17,
                18,
                19
            ],
            tabGroup: 'overview',
            order: 998
        },
        sync: {
            acl: 'g:debug',
            parts: [
                'MirrorSync'
            ],
            cfg: ({ iconfig })=>iconfig.info.mirror,
            enabled: ({ datatype, iconfig })=>[
                    0,
                    1,
                    2,
                    3,
                    21
                ].includes(datatype),
            tabGroup: 'overview',
            order: 999
        }
    }
};
export const sys = {
    tabs: {
        archive: {
            parts: [
                'ArchiveInfo'
            ]
        }
    }
};
